var _rect, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLogoProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 68,
    viewBox: "0 0 64 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#E6E8EB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_12742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.4954 51H13.5046C12.6736 51 12 50.3264 12 49.4954V18.6863C12 17.8553 12.6736 17.1816 13.5046 17.1816H50.4955C51.3264 17.1816 52 17.8553 52 18.6863V49.4954C52 50.3264 51.3264 51 50.4954 51Z",
    fill: "url(#paint0_linear_5_12742)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0001 18.6861V49.4955C52.0001 50.3261 51.3264 50.9998 50.4958 50.9998H45.586L21.353 26.7669V17.1818H50.4958C51.3264 17.1818 52.0001 17.8555 52.0001 18.6861Z",
    fill: "url(#paint1_linear_5_12742)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4952 17.1816H39.9854C40.8163 17.1816 41.49 17.8553 41.49 18.6863V49.4954C41.49 50.3264 40.8163 51 39.9854 51H50.4952C51.3261 51 51.9998 50.3264 51.9998 49.4954V18.6863C51.9998 17.8553 51.3261 17.1816 50.4952 17.1816Z",
    fill: "url(#paint2_linear_5_12742)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 42.8431V49.4954C12 50.3264 12.6736 51 13.5046 51H50.4955C51.3264 51 52.0001 50.3264 52.0001 49.4954V42.8431H12Z",
    fill: "url(#paint3_linear_5_12742)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8974 27.0246L22.9269 27.0426C23.6032 27.4532 24.4534 27.4462 25.123 27.0247C25.8072 26.6115 26.6641 26.6115 27.3483 27.0247C28.0326 27.4379 28.8894 27.4379 29.5738 27.0247L29.5738 27.0246C29.8909 26.841 30.2418 26.837 30.5952 26.9033C30.9983 26.9789 31.3727 26.6767 31.3727 26.2666V17.4876C31.3727 17.1953 31.1356 16.9583 30.8433 16.9583H21.6275C21.3352 16.9583 21.0981 17.1953 21.0981 17.4876V26.2543C21.0981 26.6619 21.4689 26.967 21.8695 26.892C22.2265 26.8251 22.5806 26.8323 22.8974 27.0246Z",
    fill: "url(#paint4_linear_5_12742)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2956 42.0566H17.2586V45.2738C17.2586 45.4022 17.3627 45.5062 17.4911 45.5062H19.2223C19.3507 45.5062 19.4548 45.4021 19.4548 45.2738V42.0566H20.4177C20.7123 42.0566 20.8886 41.7289 20.7264 41.4831L18.6654 38.3604C18.5192 38.139 18.1943 38.139 18.0481 38.3604L15.9871 41.4831C15.8248 41.7289 16.0011 42.0566 16.2956 42.0566Z",
    fill: "#C4573A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3442 46.6042H15.3689C15.2862 46.6042 15.2192 46.6712 15.2192 46.7539V47.6311C15.2192 47.7137 15.2862 47.7807 15.3689 47.7807H21.3442C21.4268 47.7807 21.4938 47.7137 21.4938 47.6311V46.7539C21.4938 46.6712 21.4268 46.6042 21.3442 46.6042Z",
    fill: "#C4573A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5882 43.2317H43.6267C43.5441 43.2317 43.4771 43.1647 43.4771 43.0821V42.2048C43.4771 42.1222 43.544 42.0552 43.6267 42.0552H46.5882C46.6708 42.0552 46.7378 42.1222 46.7378 42.2048V43.0821C46.7378 43.1647 46.6708 43.2317 46.5882 43.2317Z",
    fill: "#C4573A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3529 45.5063H43.6267C43.5441 45.5063 43.4771 45.4393 43.4771 45.3566V44.4794C43.4771 44.3967 43.544 44.3297 43.6267 44.3297H50.3529C50.4356 44.3297 50.5025 44.3967 50.5025 44.4794V45.3566C50.5025 45.4393 50.4356 45.5063 50.3529 45.5063Z",
    fill: "#C4573A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3137 47.7808H43.6267C43.5441 47.7808 43.4771 47.7138 43.4771 47.6311V46.7539C43.4771 46.6712 43.544 46.6042 43.6267 46.6042H48.3137C48.3963 46.6042 48.4633 46.6712 48.4633 46.7539V47.6311C48.4633 47.7138 48.3963 47.7808 48.3137 47.7808Z",
    fill: "#C4573A"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_5_12742)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 48,
    rx: 16,
    ry: 6,
    fill: "#7E7D99",
    fillOpacity: 0.77
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_5_12742",
    x: 2,
    y: 28,
    width: 60,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_5_12742"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_12742",
    x1: 18.7191,
    y1: 20.81,
    x2: 50.6542,
    y2: 52.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE860A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5_12742",
    x1: 49.2902,
    y1: 34.8079,
    x2: 8.11374,
    y2: 5.55296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE860A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5_12742",
    x1: 53.3292,
    y1: 25.9009,
    x2: 28.1348,
    y2: 52.4721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE860A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5_12742",
    x1: 32,
    y1: 45.3529,
    x2: 32,
    y2: 52.5839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE860A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5_12742",
    x1: 22.4144,
    y1: 18.0746,
    x2: 33.7913,
    y2: 29.4515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2575,
    stopColor: "#DCE8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7423,
    stopColor: "#B8C4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2AEE6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_12742"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(12 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogoProduct);
export default __webpack_public_path__ + "static/media/icon-logo-product.0e8fdca342ea1ac7899c4efffd00acbf.svg";
export { ForwardRef as ReactComponent };